import user from 'js/lib/user';

import type { EnrollmentChoices } from 'bundles/enroll-common/components/xdp/withEnrollment';
import type { Product } from 'bundles/enroll-common/types/productTypes';
import { hasCourse } from 'bundles/enroll-common/types/productTypes';
import { useProductFeatures } from 'bundles/enroll-common/utils/productFeatureFlags';
import { IdTypes } from 'bundles/product-features';

type ProductAndEac = Product & {
  enrollmentAvailableChoices?: EnrollmentChoices;
};

export const useShouldShowFinaid = ({ enrollmentAvailableChoices, ...product }: ProductAndEac) => {
  const { features, loading: loadingProductFeatures } = useProductFeatures({
    idType: hasCourse(product) ? IdTypes.Course : IdTypes.Specialization,
    id: hasCourse(product) ? product.course.id : product.s12n.id,
  });
  const isProductValid = features.get('globalPayments', 'enableFinancialAidLink');

  const isAuthenticated = user.isAuthenticatedUser();
  const isEligibleForVCFinaid = enrollmentAvailableChoices && enrollmentAvailableChoices.isEligibleForVCFinaid;
  const isEnrollmentValid = !isAuthenticated || isEligibleForVCFinaid;

  return !loadingProductFeatures && isProductValid && isEnrollmentValid;
};
